import { useIntl } from '@capsicum/common';

export const useNCWSendAssetCard = () => {
	const { $t } = useIntl();
	const balance = $t('ncWallet.send.assetSelector.availableToSend');

	return {
		intlText: {
			balance
		}
	};
};
